import { gql } from '@apollo/client';

import { useMutationCompat as useMutation } from '../../lib/apollo/mutationCompat';

const SIGN_AGREEMENT= gql`
  mutation($agreement: String!) 
  {
    SignAgreement(agreement: $agreement)
  }
`;

export function useAgreementMutations() {

  const [signAgreement] = useMutation(SIGN_AGREEMENT);
  
  return { signAgreement };
}
